import { render } from "./Gstr2a.vue?vue&type=template&id=7444832a"
import script from "./Gstr2a.vue?vue&type=script&lang=js"
export * from "./Gstr2a.vue?vue&type=script&lang=js"

import "./Gstr2a.vue?vue&type=style&index=0&id=7444832a&lang=css"
script.render = render

export default script